import React, { useEffect } from 'react';
import { useAppStore } from '../store';
import { getUser } from '../services/auth.service';

export function BlockedUserOverlay() {
  const { user, isBlocked, setIsBlocked } = useAppStore();

  useEffect(() => {
    if (!user || !user.username) return;
    
    let isMounted = true;
    
    const checkStatus = async () => {
       try {
           const latestUser = await getUser(user.username);
           if (isMounted && latestUser && latestUser.status === 'blocked') {
               setIsBlocked(true);
           }
       } catch(e) { 
           console.error("Failed to check user status", e);
       }
    };
    
    // Check immediately
    checkStatus();

    // Check periodically every 30 seconds
    const interval = setInterval(checkStatus, 30000);
    
    return () => {
        isMounted = false;
        clearInterval(interval);
    };
  }, [user]);

  if (!isBlocked) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-70">
       <div className="bg-white dark:bg-gray-800 p-8 rounded-lg max-w-md w-full shadow-2xl text-center">
          <h2 className="text-2xl font-bold text-green-600 mb-4">Account Suspended</h2>
          <p className="mb-6 text-gray-700 dark:text-gray-300">
             Your account has been suspended. Please contact support for more information.
          </p>
          <button 
             onClick={() => window.location.href = 'https://idearify.com/help'}
             className="bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 font-semibold"
          >
             Contact Support
          </button>
       </div>
    </div>
  );
}
